import { render, staticRenderFns } from "./TemplateEditTipoUsuario.vue?vue&type=template&id=205c8d66&scoped=true"
import script from "./TemplateEditTipoUsuario.vue?vue&type=script&lang=js"
export * from "./TemplateEditTipoUsuario.vue?vue&type=script&lang=js"
import style0 from "./TemplateEditTipoUsuario.vue?vue&type=style&index=0&id=205c8d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205c8d66",
  null
  
)

export default component.exports